import * as React from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useNavigate, useLocation } from "react-router-dom";
import useAppStore from "../appStore";


export default function DataGridTable({ data, columns }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { updateSelectedPost } = useAppStore();

    const handleOnCellClick = (params) => {
        if (params.field === "project_name" && location.pathname.includes('posts')) {
            console.log(params);
            updateSelectedPost(params.row);
            navigate("/update-post")
        }
    }

    return (
        <div className={`flex justify-center`}>
            <div className='md:max-w-[77vw] max-w-[95vw] px-4'>
                <DataGrid
                    rows={data}
                    columns={columns}
                    onCellClick={handleOnCellClick}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                            },
                        },
                    }}
                    pageSizeOptions={[10]}
                    // checkboxSelection
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                        },
                    }}
                    disableRowSelectionOnClick
                />
            </div>
        </div>
    );
}
